import React from 'react';
import Helmet from 'react-helmet';

import Layout from '../components/layout';
import Grid from '../components/grid';
import Tile from '../components/tile';
import Heading from '../components/heading';

export default ({ location: { pathname } }) => (
    <Layout pathname={pathname}>
        <div css={{ flex: 1 }}>
            <Helmet title="Calculators" meta={[{ property: 'og:title', content: 'Calculators' }]} />
            <Heading>Calculators</Heading>
            <Grid numTiles={4}>
                <Tile href="/calculators/home" title="Home" image="home" />
                <Tile href="/calculators/car" title="Car" image="car" />
                <Tile href="/calculators/investment" title="Investment" image="investment" />
                <Tile href="/terms-and-knowledge" title="Terms & Knowledge" image="terms" />
            </Grid>
        </div>
    </Layout>
);
